<template lang="">
  <div class="bbs_write">
    <div class="bbs_info">
      <div class="required">* 필수 입력사항</div>
    </div>
    <table class="bbs_tbl">
      <colgroup>
        <col style="width:140px">
        <col style="width:auto">
      </colgroup>
      <tbody>
        <tr>
          <th scope="row"><span class="txt_required">* 유형</span></th>
          <td>
            <div class="item">
              <select v-model="selectedMerchantCategorySeq" class="i_sel" style="width:260px">
                <option :value="null">카테고리 선택</option>
                <option v-for="category in merchantCategoryListForCreate" :key="category.seq" :value="category.seq">
                  {{ category.name }}
                </option>
              </select>
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row"><span class="txt_required">* 거래처코드</span></th>
          <td>
            <div class="bbs_srch">
              <input type="text" class="i_txt" name="comId" required v-model="merchant.comId">
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row"><span class="txt_required">* 비밀키</span></th>
          <td>
            <div class="bbs_srch">
              <input type="password" class="i_txt" name="secretKey" required v-model="merchant.secretKey">
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row"><span class="txt_required">* 사업자번호</span></th>
          <td>
            <div class="bbs_srch">
              <input type="text" class="i_txt" name="businessNum" required v-model="merchant.businessNum">
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row"><span class="txt_required">* 활성화 여부</span></th>
          <td>
            <div class="item">
                <span class="ui_chkbox primary lgray untxt">
                    <input type="checkbox" v-model="merchant.isActive">
                    <label></label>
                </span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="bbs_controller">
    <div class="lft_area">
      <a class="bt_base gray large_h btn_list" @click="toList">목록</a>
    </div>

    <div class="rgt_area">
      <button type="button" class="bt_base primary large_h" @click="editMerchant">저장</button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

const adminMerchantModule = "adminMerchantModule"

export default {
  props: {
    authSeq: {
      type: String,
      required: true
    }
  },
  data (){
    return {
      selectedMerchantCategorySeq: null
    }
  },
  methods: {
    ...mapActions(adminMerchantModule, [
      'requestMerchant',
      'requestMerchantEdit',
      'requestMerchantCategoryListForCreate'
    ]),

    toList () {
      this.$router.push({ name: "MerchantManageListPage" })
    },
    
    async editMerchant() {
      const formData = new FormData();
      formData.append('authSeq', this.merchant.authSeq);
      formData.append('typeSeq', this.selectedMerchantCategorySeq);
      formData.append('comId', this.merchant.comId);
      formData.append('secretKey', this.merchant.secretKey);
      formData.append('businessNum', this.merchant.businessNum);
      formData.append('isActive', this.merchant.isActive);

      if(this.selectedMerchantCategorySeq === null) {
        alert("유형을 선택해주세요.");
        return;
      }
      if(this.merchant.comId.trim() === '') {
        alert("거래처코드를 입력해주세요.");
        return;
      }
      if(this.merchant.secretKey.trim() === '') {
        alert("비밀키를 입력해주세요.");
        return;
      }
      if(this.merchant.businessNum.trim() === '') {
        alert("사업자번호를 입력해주세요.");
        return;
      }

      if (await this.requestMerchantEdit(formData)) {
        alert("저장되었습니다.")
        this.$router.push({ name: "MerchantManageListPage" })
      }
    }
  },

  computed: {
    ...mapState(adminMerchantModule, ['merchant']),
    ...mapState(adminMerchantModule, ['merchantCategoryListForCreate']),
  },

  async mounted () {
    await this.requestMerchant(this.authSeq);
    await this.requestMerchantCategoryListForCreate();

    if(this.merchant.typeSeq) {
      this.selectedMerchantCategorySeq = this.merchant.typeSeq;
    }
  }
}
</script>
<style lang="">
    
</style>